export { default } from "./CkoPaySkeleton.jsx";
